import * as Yup from 'yup';

const validationSchema = ({ t }) => Yup.object().shape({
  directorate_name: Yup.string()
    .typeError('Field must be string !')
    .required(t('general.message.field_required')),
});

export default validationSchema;
